import { Text, TextProps } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

export const BlockLink = (props: LinkProps): ReactElement | null => (
  <RouterLink style={{ lineHeight: 0, display: 'block' }} {...props} />
);

export const CustomLink = ({
  children,
  textProps,
  ...rest
}: LinkProps & { textProps?: TextProps }): ReactElement | null => (
  <RouterLink {...rest}>
    <Text as="span" {...textProps}>
      {children}
    </Text>
  </RouterLink>
);
